module.exports = __webpack_public_path__ + "img/09-cross-success.95549c41.svg";